import { U21Themes } from 'vendor/material-minimal/models';

export const consoleWarn = (arg, ...args) => {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.warn(arg, ...args);
  }
};

// Library-private cache of the theme mode last rendered by U21ComponentLibrary.
// Lets imperative entry points (e.g. U21SavingPrompt) pick up the current mode
let lastThemeMode: U21Themes = U21Themes.LIGHT;

export const setThemeMode = (mode: U21Themes) => {
  lastThemeMode = mode;
};

export const getThemeMode = () => lastThemeMode;
